import React from 'react'
import tw, { styled } from 'twin.macro'
import { useStateContext } from '../context/stateContext'
import content from './../data/content.json'
import exitIcon from './../assets/exit.svg'
import { motion } from 'framer-motion'

const Container = styled(motion.div)`
	${tw`fixed bottom-0 left-0 right-0 z-50 px-5 -top-10`}
	background: rgba(0,0,0,0.25);
`
const Wrap = styled.div`
	${tw`absolute flex flex-col justify-center items-center top-1/2 left-5 right-5 sm:right-auto sm:left-1/2 bg-black text-white transform sm:-translate-x-1/2 -translate-y-1/2 max-h-[80vh] sm:w-[80%] min-h-[460px] border border-white px-0 pb-5`}
`
const PopupBody = styled.div`
	${tw`w-full h-full px-5 overflow-y-auto`}

	::-webkit-scrollbar {
		width: 3px;
	}
	::-webkit-scrollbar-track {
		background: #101010;
		width: 3px;
	}
	::-webkit-scrollbar-thumb {
		background: #f1fc00;
		border-radius: 0px;
		width: 3px;
	}
	::-webkit-scrollbar-thumb:hover {
		background: #101010;
	}
`
const ButtonExit = styled.p`
	${tw`absolute cursor-pointer top-4 right-4 sm:top-8 sm:right-8`}
`
const Text = styled.p`
	${tw`w-full mx-auto my-5 text-sm text-white sm:text-base sm:my-10 sm:px-6`}

	h2 {
		${tw`pb-3 pr-5 text-xl text-center sm:text-2xl text-yellow`}
	}
`
const ButtonBackToGame = styled.button`
	${tw`bg-pink text-white md:text-lg py-2 md:py-4 px-4 uppercase md:tracking-wider min-w-[180px] md:min-w-[240px]`}
`
// const ButtonBackToHome = styled.button`
// 	${tw`w-full p-4 mb-5 text-lg font-semibold tracking-wider text-center uppercase border cursor-pointer sm:w-3/5 rounded-xl text-blue border-blue`}

// 	a {
// 		${tw`inline-block w-full p-4`}
// 	}
// `

const Popup = () => {
	const stateContext = useStateContext()
	const { locale } = stateContext.state
	const t = content.langs

	const popupVariants = {
		init: {
			opacity: 0,
			visibility: 'hidden',
			y: 20,
			transition: {
				duration: 0.7,
				type: 'spring',
			},
		},
		show: {
			opacity: 1,
			visibility: 'visible',
			y: 0,
			transition: {
				duration: 0.7,
				type: 'spring',
			},
		},
		exit: {
			y: 20,
			opacity: 0,
			transitionEnd: {
				visibility: 'hidden',
			},
			transition: {
				duration: 0.7,
				type: 'spring',
			},
		},
	}

	return (
		<Container variants={popupVariants} initial='init' animate='show' exit='exit'>
			<Wrap>
				<PopupBody>
					<ButtonExit onClick={() => stateContext.dispatch({ action: 'SET_POPUP_STATUS', data: false })}>
						<img src={exitIcon} alt='' />
					</ButtonExit>
					<Text>
						<h2>Teilnahmebedingungen für das Gewinnspiel</h2>
						<br />
						<strong>Veranstalter:</strong> Das Gewinnspiel wird von der Hattenberger GmbH (im Folgenden als "Veranstalter" bezeichnet) veranstaltet.
						<br />
						<br />
						<strong>Teilnahmeberechtigung:</strong> Teilnahmeberechtigt sind alle Personen ab 18 Jahren, die ihren Wohnsitz in Deutschland, Österreich oder der Schweiz haben. Mitarbeiter des Veranstalters und deren Angehörige sind von der
						Teilnahme ausgeschlossen.
						<br />
						<br />
						<strong>Zeitraum:</strong> Das Gewinnspiel findet im Zeitraum vom 18.12.2023 bis zum 31.12.2023 statt.
						<br />
						<br />
						<strong>Teilnahme:</strong> Die Teilnahme am Gewinnspiel erfolgt durch die Teilnahme am “Memory”-Spiel und der Einreichung des eigens erreichten Highscores. Die Teilnahme ist kostenlos und unabhängig vom Erwerb von Waren oder
						Dienstleistungen.
						<br />
						<br />
						<strong>Gewinn:</strong> Die Gewinner:innen werden unter den Top10 ausgelost und per E-Mail benachrichtigt. Der Gewinn ist nicht übertragbar und kann nicht in bar ausgezahlt werden.
						<br />
						<br />
						<strong>Datenschutz:</strong> Mit der Teilnahme am Gewinnspiel erklärt sich der Teilnehmer damit einverstanden, dass seine Daten für die Durchführung des Gewinnspiels verwendet werden dürfen. Die Daten werden nicht an Dritte
						weitergegeben und nach Abschluss des Gewinnspiels gelöscht.
						<br />
						<br />
						<strong>Ausschluss:</strong> Der Veranstalter behält sich das Recht vor, Teilnehmer bei Verstoß gegen diese Teilnahmebedingungen vom Gewinnspiel auszuschließen.
						<br />
						<br />
						<strong>Änderungen:</strong> Der Veranstalter behält sich das Recht vor, das Gewinnspiel oder die Teilnahmebedingungen jederzeit zu ändern oder zu beenden.
						<br />
						<br />
						<strong>Haftung:</strong> Der Veranstalter haftet nicht für Schäden, die durch die Teilnahme am Gewinnspiel oder die Nutzung des Gewinns entstehen.
						<br />
						<br />
						<strong>Sonstiges:</strong> Sollten einzelne Bestimmungen dieser Teilnahmebedingungen unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt.
						<br />
						<br />
						<strong>Gerichtsstand:</strong> Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist München.
						<br />
						<br />
						Durch die Teilnahme am Gewinnspiel akzeptiert der Teilnehmer diese Teilnahmebedingungen. Der Rechtsweg ist ausgeschlossen.
					</Text>

					{/* <ButtonBackToGame onClick={() => stateContext.dispatch({ action: 'SET_POPUP_STATUS', data: false })}>{t[locale].ButtonBackToGame}</ButtonBackToGame> */}
					{/* <ButtonBackToHome
						onClick={() => {
							stateContext.dispatch({ action: 'SET_POPUP_STATUS', data: false })
							stateContext.dispatch({ action: 'SET_GAME_STATUS', data: 'beforeInit' })
						}}
					>
						{t[locale].ButtonBackToHome}
					</ButtonBackToHome> */}
				</PopupBody>
			</Wrap>
		</Container>
	)
}

export default Popup
